import { ref, computed, watch } from 'vue'
import { useRecordMeta } from './useRecordMeta'

const identityFieldsPerType = { sequencinglibrary: ['barcode'] }
const requiredFields = ['specimen', 'primary_project', 'organism']

export const useSample = (typeId, sampleFields) => {
  const sampleTypeId = ref(typeId)
  const sampleIdentityFields = ref([])
  const sampleRequiredFields = ref(sampleFields || requiredFields)
  watch(
    () => sampleTypeId.value,
    (v) => {
      sampleIdentityFields.value = identityFieldsPerType[v.toLowerCase()] || []
    },
    { immediate: true },
  )
  const sampleFieldsNames = computed(() => [
    'name',
    ...sampleRequiredFields.value,
    ...sampleIdentityFields.value,
  ])

  const metaResult = useRecordMeta({
    appName: 'stocks',
    modelName: 'samples',
    modelType: sampleTypeId,
  })

  // modelAttributes is already merged model + view attributes
  const sampleFieldsModels = metaResult.modelAttributes

  const defaultModifiableSample = computed(() => {
    return Object.entries(sampleFieldsModels.value).reduce(
      (modifiableSample, [attrName, attr]) => {
        if (attr.readonly) return modifiableSample
        return {
          ...modifiableSample,
          [attrName]: { value: attr.default },
        }
      },
      {},
    )
  })

  return {
    sampleMeta: metaResult.meta,
    isMetaReady: metaResult.isMetaReady,
    sampleFieldsNames,
    sampleIdFieldsNames: computed(() => [
      'name',
      ...sampleIdentityFields.value,
    ]),
    sampleFieldsModels,
    defaultSample: metaResult.defaultRecord,
    defaultModifiableSample,
  }
}
